module.exports = __webpack_public_path__ + "img/emiliocgomez.3453c977.jpg";